var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"herospark-banner-sidenav"}},[_c('Content',{attrs:{"id":_vm.active.id,"currentView":_vm.currentView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }